import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoleBasedAdminService } from 'app/modules/role-based-admin/role-based-admin.service';
import { PageService } from 'app/services/page-service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-modern-sidebar',
  templateUrl: './modern-sidebar.component.html',
  styles: [
  ],
})
export class ModernSidebarComponent implements OnInit {
  
  isCollapsed = false;
  superAdminEnable = false;
  logoImage = environment.sidebarLogo
  logoIcon = environment.navLogo
openMenu: string | null = null;

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    const mainPanel =
      document.querySelector(".main-panel") as HTMLElement;
    const footer =
      document.querySelector(".footer") as HTMLElement;


    if (this.isCollapsed) {
      mainPanel.style.width =
        "calc(100% - 80px)";
      if (footer)
        footer.style.width =
          "calc(100% - 80px)";
    }

    else {
      mainPanel.style.width =
        "calc(100% - 260px)";
      if (footer)
        footer.style.width =
          "calc(100% - 260px)";
    }
  }

  public menuItems: any[];
  userDetails: any;
  roleName = "";
  showReferral = false;
  clientDetails =
    JSON.parse(localStorage.getItem("client"));
  projectName =
    this.clientDetails?.projectName
    || environment.projectName;
  defaultLogo =
    this.clientDetails?.logo
    || "/assets/images/marketplaceLogo.png";
  routeUrl = "";
  accountRoleId = "";
  adminEnable = false;
  roleUserEnable = false;
  permissions: any = {};
  menuVisibility: any = {};
  cityDashboardDisabled = false;
  couponFeature = false;
  platformConfig = false;
  notification = false;
  paymentSettings = false;
  faq = false;
  banners = false;
  platformConfigData = [];
   serviceMenu = false;
    platformType: any = [];




  constructor(
    public router: Router,
    public service: PageService,
    public roleService: RoleBasedAdminService,
  ) {}
 

  ngOnInit() {
      this.userDetails =
        JSON.parse(
          localStorage.getItem("userDetails")
        );
        console.log("userDetails", this.userDetails);

        if(this.userDetails?.code === "SUPER_ADMIN") {
          this.superAdminEnable = true;
        } else {
          this.menuVisibility =
          this.generateMenuVisibility();
        }
  }


  generateMenuVisibility() {
    const visibility = {};
    for (
      const key in this.permissions
    ) {
      visibility[key] =
        this.permissions[key]?.view || false;
    }
    return visibility;

  }

  toggleMenu(menu: string) {
  this.openMenu = this.openMenu === menu ? null : menu;
}
}